module.exports = __webpack_public_path__ + "img/2W0A5374-min.a1fbb1c9.jpg";